import { render, staticRenderFns } from "./editFeature.vue?vue&type=template&id=47e43b9b&scoped=true"
import script from "./editFeature.vue?vue&type=script&lang=js"
export * from "./editFeature.vue?vue&type=script&lang=js"
import style0 from "./editFeature.vue?vue&type=style&index=0&id=47e43b9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e43b9b",
  null
  
)

export default component.exports